import { dispatchSendSocketMessage } from 'store/dispatcher'

import * as constants from './constants'

export const sendRevertGesture = gesture_pk => {
    if (!gesture_pk) return

    const data = { gesture_pk }

    dispatchSendSocketMessage({ action: constants.REVERT_GESTURE, data })
}

export const sendGesture = (
    gesture,
    gesture_type = '',
    mode = 'public',
    toUser = null
) => {
    const data = {
        to_user: toUser,
        mode,
        gesture,
    }

    if (gesture_type) {
        data.gesture_type = gesture_type
    }

    dispatchSendSocketMessage({ action: constants.GESTURE, data })
}
